.callout {
	background-color: var(--color-primary-background);
	border: 1px solid var(--color-primary);
	border-radius: var(--radius-lg);
	display: grid;
	align-items: start;
	padding: var(--size-5);
}
